
export const courseData = {
  title: "Advanced Mathematics",
  subtitle: "Master complex mathematical concepts",
  description:
    "Comprehensive course covering advanced mathematical topics including differential equations, linear algebra, complex analysis, and abstract algebra. Students will develop strong problem-solving skills and deep mathematical intuition through hands-on exercises and real-world applications.",
  thumbnail: "https://example.com/images/advanced-math-course.jpg",
  level: "advanced",
  category: "Mathematics",
  subcategory: "Pure Mathematics",
  price: {
    amount: 599.99,
    currency: "USD",
    discounted: 499.99,
  },
  schedule: {
    startDate: "2024-01-15",
    endDate: "2024-04-30",
    sessionsPerWeek: 3,
    timeSlots: [
      "Monday 10:00-12:00",
      "Wednesday 10:00-12:00",
      "Friday 10:00-12:00",
    ],
  },
  maxStudents: 25,
  prerequisites: [
    "Calculus I & II",
    "Basic Linear Algebra",
    "Mathematical Proof Writing",
    "Strong analytical thinking skills",
  ],
  learningOutcomes: [
    "Solve complex differential equations using advanced techniques",
    "Apply linear algebra concepts to real-world problems",
    "Understand and work with complex number theory",
    "Master abstract algebra fundamentals",
    "Develop mathematical proof writing skills",
  ],
  instructors: [
    "Dr. Sarah Martinez, PhD",
    "Prof. James Wilson, PhD",
    "Dr. Michael Chang, PhD",
  ],
  modules: [
    {
      title: "Differential Equations",
      description:
        "Advanced study of ordinary and partial differential equations",
      duration: "3 weeks",
      topics: [
        "First-order ODEs",
        "Second-order ODEs",
        "Systems of ODEs",
        "Introduction to PDEs",
      ],
    },
    {
      title: "Linear Algebra Advanced Concepts",
      description: "Deep dive into advanced linear algebra topics",
      duration: "4 weeks",
      topics: [
        "Vector Spaces",
        "Linear Transformations",
        "Eigenvalues and Eigenvectors",
        "Jordan Canonical Form",
      ],
    },
    {
      title: "Complex Analysis",
      description: "Study of functions of complex variables",
      duration: "4 weeks",
      topics: [
        "Complex Functions",
        "Cauchy's Theorem",
        "Residue Theory",
        "Conformal Mapping",
      ],
    },
  ],
  languages: ["English", "Spanish"],
  certification: true,
  tags: [
    "mathematics",
    "advanced math",
    "differential equations",
    "linear algebra",
    "complex analysis",
    "pure mathematics",
  ],
  duration: {
    weeks: 15,
    hoursPerWeek: 12,
  },
};